//@flow

// Vendors
import React from 'react';
import { Switch, Route } from 'react-router-dom';

// Pages
import getPages from '../pages';
import PAGE_TYPES from '../pages/pageTypes';

const { LoginPage } = getPages(PAGE_TYPES.PUBLIC_BASIC);

const RoutesPublicBasic = () => (
  <Switch>
    <Route exact path="/" component={LoginPage} />
    <Route exact path="/es" component={LoginPage} />
    <Route
      exact
      path="/dmv/vehicle-registration-renewal"
      component={LoginPage}
    />
    <Route
      exact
      path="/es/dmv/renovacion-registro-vehiculo"
      component={LoginPage}
    />
    <Route
      exact
      path="/es/dmv/renovacion-registro-vehiculo"
      component={LoginPage}
    />
    <Route
      exact
      path="/dps/driver-license-id-renewal-replacement"
      component={LoginPage}
    />
    <Route
      exact
      path="/es/dps/renovacion-licencia-de-conducir"
      component={LoginPage}
    />
    <Route
      exact
      path="/tdlr/massage-therapy-license-renewals"
      component={LoginPage}
    />
    <Route
      exact
      path="/es/tdlr/renovacion-licencia-de-terapia-masaje"
      component={LoginPage}
    />
    <Route exact path="/tpwd/boat-services" component={LoginPage} />
    <Route
      exact
      path="/es/tpwd/servicios-de-embarcación"
      component={LoginPage}
    />
    <Route path="/sign-in" component={LoginPage} />
  </Switch>
);

export default RoutesPublicBasic;
